import { createFileRoute } from '@tanstack/react-router';
import { ProviderCredentialsSettings } from '@/components/providers/provider-credentials-settings';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/web-browsing/providers',
)({
  component: () => (
    <ProviderCredentialsSettings
      header={false}
      capabilities={['web_search']}
      title="Web Search Providers"
      description="Credentials for the research agents' web-search providers (Brave, Tavily). Stored encrypted; secrets are write-only."
    />
  ),
});
